import {useLocation, Link} from '@remix-run/react';
import {useTranslation} from 'react-i18next';
import {twMerge} from 'tailwind-merge';
import {ProductSummary} from '~/features/shared';

interface ProductItemProps {
  product: ProductSummary;
  className?: string;
  imageClassName?: string;
}

type TagColorType = {
  backgroundColor: string;
  color: string;
};

const DEFAULT_TAG_COLOR: TagColorType = {
  backgroundColor: 'bg-blue-100',
  color: 'text-blue-800',
};

const TAG_COLORS: Record<string, undefined | TagColorType> = {};

export function ProductItem({
  product,
  className,
  imageClassName,
}: ProductItemProps) {
  const {title, tags: categories, handle, image, category} = product;

  const {t} = useTranslation();
  const location = useLocation();

  const to = category
    ? `/productos/${category}/${handle}`
    : `/productos/${handle}`;

  const state = {
    from: location.pathname,
  };

  return (
    <div className={className}>
      {image?.image ? (
        <Link to={to} state={state}>
          <img
            className={twMerge('object-contain w-full h-full', imageClassName)}
            src={image.image.url}
            alt={image.image.altText}
          />
        </Link>
      ) : null}

      <div>
        <h2 className="mb-2 text-2xl font-bold uppercase hover:underline text-blue-dark decoration-blue-dark">
          <Link to={to} state={state}>
            {title}
          </Link>
        </h2>

        <div className="flex flex-wrap gap-2">
          {categories.map((tag) => {
            const color = TAG_COLORS[tag] ?? DEFAULT_TAG_COLOR;

            return (
              <span
                className={`text-xs rounded-md py-1 px-2 ${color.backgroundColor} ${color.color}`}
                key={tag}
              >
                {t(tag)}
              </span>
            );
          })}
        </div>
      </div>
    </div>
  );
}
